import { getNotificationContent } from './Popup.repo'
import moment from 'moment'
import {
  PREORDER_START_DATE,
  COLLECTION_END_DATE,
  PREORDER_END_DATE,
} from '../../Constants'

export const getPopupMessage = async () => {
  const defaultPopupNotificationMessage =
    `<p>Collection and pre-order begin ${moment(PREORDER_START_DATE).format(
      'dddd, DD MMM, hh:mma'
    )}!</p>` +
    `<br/><p>But #KeepCalm - there are sufficient stocks in all sizes! Avoid the rush on the first two days and observe safe distancing. Pre-order ends on ${moment(
      PREORDER_END_DATE
    ).format('dddd, DD MMM, hh:mma')}. Collection ends ${moment(
      COLLECTION_END_DATE
    ).format('dddd, DD MMM, hh:mma')}.</p>`

  const popupNotification = await getNotificationContent().catch(() => ({
    message: { 'en-US': defaultPopupNotificationMessage }
  }))
  return popupNotification.message['en-US']
}
